import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import IndustryWorkSpaceMembers from "./IndustryWorkSpaceMembers";
import AddWorkSpaceMemberModal from "./AddWorkSpaceMemeberModal";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const IndustryWorkSpaces = () => {
  const {university_name,dean_name,department_name}=useParams()
  const navigate = useNavigate();
  const [lab_groups, setLabGroups] = useState([]);
  const [search, setSearch] = useState("");
  const [open,setOpen] = useState(false)
  const [workspaceName,setWorkSpaceName] = useState("")
  const [workSpaceId,setWorkSpaceId] = useState("")
  const [isOpen,setIsOpen] = useState(false)
  // console.log("The labgroups are:",lab_groups)
   const fetchLabGroups = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/marketplace/industry/workspace/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
        });
        // console.log("The lab groups are:",res)
        setLabGroups(res?.data || []);
        // console.log("The lab groups are:",res?.data)
      } catch (error) {
        console.log("Error while getting profiles", error);
        setLabGroups([]);
      }
    };
  useEffect(() => {
    fetchLabGroups();
  }, []);

  // Inline filtering
  const filteredGroups = lab_groups?.filter(
    (workspace) =>
      workspace?.workspace_name?.toLowerCase().includes(search.toLowerCase()) 
  );
//   ||
//       dean?.profile_data?.email?.toLowerCase().includes(search.toLowerCase())
const handleDelete = async (id) => {

    const confirmDelete = window.confirm("Are you sure you want to delete this Lab group?");
    
    if (!confirmDelete) {
        return; // Stop if user clicks Cancel
    }

    try {
        const res = await axios.delete(
            `${BASE_URL}/marketplace/university/labhead/group/${id}/`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    "x-api-key": process.env.REACT_APP_X_API_KEY,
                },
            }
        );

        if (res.status === 204) {
            alert("Lab group Deleted Successfully");
            fetchLabGroups();
        }

    } catch (error) {
        console.log("Error while deleting lab group", error);
    }
};

  return (
    <>
   <div className="p-6 max-w-6xl mx-auto">
  {/* Header */}
  <div className="flex items-center gap-3 mb-6">
    <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
      <svg className="w-6 h-6 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    </div>
    <div>
      <h1 className="text-2xl font-bold text-gray-900">Industry WorkSpaces</h1>
      <p className="text-sm text-gray-500 mt-1">
        List of all Idustry workspaces with their details.
      </p>
    </div>
  </div>

  {/* Search and Add Bar */}
  <div className="w-full flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
  {/* Search Input */}
  <div className="relative flex-1 w-full">
    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>
    <input
      type="text"
      placeholder="Search by name or email..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>

  {/* Add Button */}
  {/* <button
    onClick={() => navigate(`/marketplace/${university_name}/${dean_name}/${department_name}/${lab_name}/labhead/lab_group/add`)}
    className="flex items-center justify-center gap-2 px-5 py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
  >
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
    </svg>
    Add Lab Group
  </button> */}
</div>


  {/* Table */}
  <div className="border border-gray-200 rounded-xl overflow-hidden">
    <table className="w-full">
      <thead className="bg-gray-50 border-b border-gray-200">
        <tr>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">WorkSpace Logo</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Name</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Description</th>
          <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">Actions</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {filteredGroups?.map((group) => (
          <React.Fragment key={group.id}>
             <tr  className="hover:bg-gray-50 transition-colors">
            <td className="px-6 py-4">
              <div className="relative w-10 h-10">
                <img
                  src={group?.workspace_logo}
                  alt={group?.workspace_name}
                  className="w-10 h-10 rounded-xl object-cover border border-gray-200"
                />
              </div>
            </td>
            <td className="px-6 py-4">
              <p className="text-sm font-medium text-gray-900">{group?.workspace_name}</p>
            </td>
            <td className="px-6 py-4">
              <p className="text-sm text-gray-600 overflow-hidden text-ellipsis line-clamp-2">{group?.workspace_description}</p>
            </td>
            <td className="flex gap-2 px-6 py-4">
              <button
                 onClick={()=>{
    setOpen(true);
    setWorkSpaceName(group?.workspace_name);
    setWorkSpaceId(group?.id);
  }}
                    className="px-3 py-2 bg-[#0f6abf] whitespace-nowrap text-white text-xs font-medium rounded-lg hover:bg-[#0a5ca8] transition-colors flex items-center gap-1"
                  >
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                    </svg>
                    Add Member
                  </button>
<button
  // onClick={()=>{
  //   setOpen(true);
  //   setGroupName(group?.group_name);
  //   setGroupId(group?.id)
  // }}
  className="px-3 py-2 bg-[#0f6abf] whitespace-nowrap text-white text-xs font-medium rounded-lg hover:bg-[#0a5ca8] transition-colors flex items-center gap-1"
>
  {/* Chat Icon */}
  <svg
    className="w-3.5 h-3.5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4-.8L3 20l1.2-3.6A7.962 7.962 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
    />
  </svg>

  Chat
</button>
                  <button
                    // onClick={()=> navigate( `/marketplace/${university_name}/${dean_name}/${department_name}/lab/labhead/lab_group/edit/${group?.id}`)}
                    className="w-9 h-9 flex items-center justify-center bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
                    title="Edit Module"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                  </button>

                  <button
                    // onClick={()=>handleDelete(group?.id)}
                    className="w-9 h-9 flex items-center justify-center bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors"
                    title="Delete Module"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
            </td>
          </tr>
           <tr  className="hover:bg-gray-50 transition-colors">
            <td colSpan={4} className="px-6 py-4">
              <IndustryWorkSpaceMembers members={group?.members} fetchLabGroups={fetchLabGroups}/>
            </td>
           </tr>
          </React.Fragment>
        ))}

        {filteredGroups?.length === 0 && (
          <tr>
            <td colSpan={4} className="px-6 py-12 text-center">
              <div className="flex flex-col items-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <p className="text-gray-500 font-medium">No groups found</p>
                <p className="text-sm text-gray-400 mt-1">Add a Lab group to get started</p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>
<AddWorkSpaceMemberModal
  isOpen={open}
  onClose={() => setOpen(false)}
  workspaceName={workspaceName}
  workSpaceId={workSpaceId}
  fetchLabGroups={fetchLabGroups}
/>
{/* <ChatModal
  isOpen={open}
  onClose={() => setOpen(false)}
  groupName={groupName}
  groupId={groupId}
/> */}
</>
  );
};

export default IndustryWorkSpaces;
